import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import SobreSection from "./components/SobreSection";
import ServicosSection from "./components/ServicosSection";
import ComoFuncionaSection from "./components/ComoFuncionaSection";
import DiferenciaisSection from "./components/DiferenciaisSection";
import ContatoSection from "./components/ContatoSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div style={{ fontFamily: "Montserrat, sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <SobreSection />
        <ServicosSection />
        <ComoFuncionaSection />
        <DiferenciaisSection />
        <ContatoSection />
      </main>
      <Footer />
    </div>
  );
}
